'use strict';

require('./lib/rng-browser.js');
var bytesToUuid$1 = require('./lib/bytesToUuid.js');
var rngBrowser = require('../../_virtual/rng-browser.js_commonjs-module.js');

var rng = rngBrowser.rngBrowser.exports;
var bytesToUuid = bytesToUuid$1;

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

var v4_1 = v4;

module.exports = v4_1;
